import { render, staticRenderFns } from "./CreateApiPopup.vue?vue&type=template&id=5356224e&scoped=true&"
import script from "./CreateApiPopup.vue?vue&type=script&lang=js&"
export * from "./CreateApiPopup.vue?vue&type=script&lang=js&"
import style0 from "./CreateApiPopup.vue?vue&type=style&index=0&id=5356224e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5356224e",
  null
  
)

export default component.exports